import styled, { css } from 'styled-components/macro';

export const InfoIconDiv = styled.div`
  position: relative;
  display: inline-block;
  transform: translateY(-1px);
  margin-right: 5px;
  z-index: 1;
  cursor: pointer;
  ${props =>
    props.smallIcon &&
    css`
      margin-top: 2px;
      svg {
        height: 1.3rem;
        width: 1.3rem;
      }
    `}
  svg {
    margin-left: 5px;
  }
`;
